// Append wishlist icon Header
document.addEventListener("DOMContentLoaded", function () {

    setTimeout(() => {

        const cartDiv = document.querySelector('.header__cart');
        const wishlistDiv = document.querySelector('.Vtl-WishlistHeaderWrapper');

        if (cartDiv && wishlistDiv) {
            cartDiv.parentNode.insertBefore(wishlistDiv, cartDiv.nextSibling);
        }

    }, 1000);

});


//Tab Section Js

document.addEventListener('DOMContentLoaded', function () {
  const tabsWrappers = document.querySelectorAll('.product-tabs');

  tabsWrappers.forEach(function (wrapper) {
    const tabs = wrapper.querySelectorAll('.product-tabs__tab');
    const panels = wrapper.querySelectorAll('.product-tabs__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = tab.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));

        tab.classList.add('is-active');
        wrapper.querySelector('[data-panel="' + target + '"]').classList.add('is-active');
      });
    });
  });
});

// Complimentary Service Pop Up js 

// function showCompServicePopup(productUrl) {
//   let popup = document.getElementById('comp-service-popup-overlay');
//   if (!popup) {
//     const div = document.createElement('div');
//     div.innerHTML = `
//       <div id="comp-service-popup-overlay">
//         <div id="comp-service-popup-box">
//           <p>Please select a <strong>Complimentary Service</strong> before adding to cart.</p>
//           <div id="comp-popup-buttons">
//             <button id="comp-popup-close">Cancel</button>
//             <a id="comp-popup-goto" href="#" style="display:none;">Go to Product</a>
//           </div>
//         </div>
//       </div>
//     `;
//     document.body.appendChild(div);
//     popup = document.getElementById('comp-service-popup-overlay');
//     document.getElementById('comp-popup-close').addEventListener('click', () => popup.style.display = 'none');
//     popup.addEventListener('click', (e) => { if (e.target === popup) popup.style.display = 'none'; });
//   }

//   const gotoBtn = document.getElementById('comp-popup-goto');
//   if (productUrl) {
//     gotoBtn.href = productUrl;
//     gotoBtn.style.display = 'inline-block';
//   } else {
//     gotoBtn.style.display = 'none';
//   }

//   popup.style.display = 'flex';
// }


// Data Share product page in complimentary  
// document.addEventListener("DOMContentLoaded", function () {
//     const checkboxes = document.querySelectorAll(".comp-service-check");
//     const hiddenInput = document.getElementById("comp-service-hidden");

//     // Default value
//     hiddenInput.value = "None selected";

//     checkboxes.forEach((checkbox) => {
//         checkbox.addEventListener("change", function () {
//             const selected = Array.from(checkboxes)
//                 .filter(cb => cb.checked)
//                 .map(cb => cb.value);

//             if (selected.length > 0) {
//                 hiddenInput.value = selected.join(", ");
//             } else {
//                 hiddenInput.value = "None selected";
//             }
//         });
//     });
// });

document.querySelectorAll('.size-guide-btn').forEach(button => {
  button.addEventListener('click', function () {
    document
      .getElementById(this.dataset.popup)
      .classList.add('active');
  });
});

document.querySelectorAll('.close-popup').forEach(close => {
  close.addEventListener('click', function () {
    this.closest('.pdf-popup').classList.remove('active');
  });
});

// Product page share icon

function shareToInstagram() {
  if (navigator.share) {
    navigator.share({
      title: "{{ product.title | escape }}",
      text: "Check out this product",
      url: "{{ shop.url }}{{ product.url }}"
    });
  } else {
    navigator.clipboard.writeText("{{ shop.url }}{{ product.url }}");
    alert("Product link copied! You can now paste it on Instagram.");
  }
}